import makeStyles from '@mui/styles/makeStyles';

export const useSettingsStyles = makeStyles((theme) => ({
    dialogContent: {
        backgroundColor: theme.palette.mode === 'dark' ? '#252525' : '#ebebeb',
        height: '100vh',
        padding: 10,
    },
    divRow: {
        display: 'flex',
        flexWrap: 'nowrap',
        flexDirection: 'row',
        alignItems: 'center',
    },
    title: {
        // fontWeight: 'bold',
        fontSize: 'large',
    },
    buttons: {
        marginLeft: 'auto',
        gap: 10,
    },
    divider: {
        margin: '10px 0',
    },
    menu: {
        width: '20%',
        borderRight: `1px solid ${theme.palette.mode === 'dark' ? '#404040' : '#cecece'}`,
        height: 'calc(100vh - 80px)',
    },
    menuItem: {
        display: 'flex',
        flexWrap: 'nowrap',
        flexDirection: 'row',
        alignItems: 'center',
        color: 'grey',
        gap: 10,
        minHeight: 40,
    },
    menuItemSelected: {
        borderRadius: 6,
        borderRight: '3px solid #2180F7',
        display: 'flex',
        alignItems: 'center',
        color: theme.palette.bookAdmissions.settingMenuItemSelectedText,
        backgroundColor: theme.palette.bookAdmissions.settingMenuItemSelectedBackground,
    },
    content: {
        paddingLeft: 10,
        width: '80%',
        height: 'calc(100vh - 80px)',
        overflow: 'auto',
    },
    contentBox: {
        borderRadius: 8,
        margin: 10,
        backgroundColor: theme.palette.mode === 'dark' ? '#313233' : '#bfc2c7',
    },
    contentTitle: {
        borderBottom: `2px solid ${theme.palette.mode === 'dark' ? '#252525' : '#ebebeb'}`,
        padding: 10,
    },
    contentChildren: {
        padding: 10,
    },
    specIcon: {
        backgroundColor: theme.palette.mode === 'light' ? '#D2D5D9' : '#3D3E40',
        borderRadius: 6,
        display: 'flex',
        flexWrap: 'nowrap',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 10,
        fontSize: 'small',
        minHeight: 30,
        maxHeight: 30,
        minWidth: 50,
        padding: '5px 15px',
        cursor: 'pointer',
        '&.active': {
            backgroundColor: theme.palette.primary.main,
        },
    },
    activeChip: {
        backgroundColor: theme.palette.primary.main,
    },
    backItem: {
        backgroundColor: theme.palette.background.paperDarker,
        width: '98%',
        padding: 10,
        borderRadius: 6,
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        fontWeight: 'bold',
        height: 60,
        marginTop: 10,
    },
    backIcon: {
        backgroundColor: theme.palette.inPatient.accordionBackground,
    },
    chipContainer: {
        backgroundColor: theme.palette.inPatient.inputBackground,
        padding: '5px 10px',
        borderRadius: 6,
        fontWeight: 'bold',
        display: 'flex',
        alignItems: 'center',
        gap: 5,
    },
    chipIcon: {
        color: theme.palette.primary.main,
    },
}));